import { createFileRoute } from "@tanstack/react-router";
import { i18nLinks, i18nOgMeta, localeUrl } from "@/lib/seo";
import { m } from "@/paraglide/messages";
import { SignatureMakerHub } from "@/tools/signature-maker/pages/SignatureMakerHub";

const PATH = "/signature-maker";

export const Route = createFileRoute("/signature-maker/")({
  ssr: true,
  head: () => ({
    meta: [
      { title: m.sig_hub_meta_title() },
      { name: "description", content: m.sig_hub_meta_description() },
      { property: "og:title", content: m.sig_hub_meta_title() },
      { property: "og:description", content: m.sig_hub_meta_description() },
      ...i18nOgMeta(PATH),
    ],
    links: [...i18nLinks(PATH)],
    scripts: [
      {
        type: "application/ld+json",
        children: JSON.stringify({
          "@context": "https://schema.org",
          "@type": "BreadcrumbList",
          itemListElement: [
            {
              "@type": "ListItem",
              position: 1,
              name: m.sig_breadcrumb_home(),
              item: localeUrl(`/`),
            },
            {
              "@type": "ListItem",
              position: 2,
              name: m.sig_tool_name(),
              item: localeUrl(`${PATH}`),
            },
          ],
        }),
      },
    ],
  }),
  component: SignatureMakerHub,
});
